import React, { useState, useEffect, useRef } from "react";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import axios from "../api/axios";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { Password } from "primereact/password";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Checkbox } from "primereact/checkbox";
function TablaUsuarios(Authentication) {
  let emptyUsuario = {
    _id: null,
    nombre: "",
    email: "",
    password: "",
    roles: { User: 2001 },
    Empresas: [
      {
        rfc: "",
        nombre: "",
        registrosPatronales: [{ registroPatronal: "", nombre: "" }],
      },
    ],
    cntEmpresas: 0,
    cntRegistrosPatronales: 0,
  };

  const [usuarios, setUsuarios] = useState(null);
  const [newUsuarioDialog, setNewUsuarioDialog] = useState(false);
  const [editUsuarioDialog, setEditUsuarioDialog] = useState(false);
  const [usuario, setUsuario] = useState(emptyUsuario);
  const [selectedEmpresas, setSelectedEmpresas] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const toast = useRef(null);
  const dt = useRef(null);
  const axiosPrivate = useAxiosPrivate();
  const GetUsuarios = async () => {
    await axiosPrivate.get("/admin/users").then((response) => {
      const data = response.data;
      console.log(data);
      setUsuarios(data);
    });
  };

  useEffect(() => {
    GetUsuarios();
  }, []);

  const openNew = () => {
    setUsuario(emptyUsuario);
    setSubmitted(false);
    setNewUsuarioDialog(true);
  };

  const hideDialog = () => {
    setSubmitted(false);
    setNewUsuarioDialog(false);
  };

  const hideDialogEdit = () => {
    setSubmitted(false);
    setEditUsuarioDialog(false);
  };

  const saveUsuario = async () => {
    setSubmitted(true);
    console.log("saveUsuario", usuario);

    if (true === true) {
      try {
        if (usuario._id) {
          //editar usuario
          console.log("editar usuario", usuario);
          const response = await axios.put(
            "admin/users/update",
            JSON.stringify({ usuario }),
            {
              headers: { "Content-Type": "application/json" },
              withCredentials: true,
            }
          );
          console.log(response.data);
          GetUsuarios();
          toast.current.show({
            severity: "success",
            summary: "Successful",
            detail: response.data.success,
            life: 3000,
          });
        } else {
          //nuevo usuario
          const response = await axios.post(
            "admin/users/new",
            JSON.stringify({ usuario }),
            {
              headers: { "Content-Type": "application/json" },
              withCredentials: true,
            }
          );
          console.log(response.data);
          //setNewUsuarioDialog(false);
          //setUsuario(emptyUsuario);
          confirmDialog({
            message:
              "Desea enviar la informacion de acceso al usuario al correo " +
              usuario.email +
              " ?",
            header: "Envio de correo",
            icon: "pi pi-info-circle",
            defaultFocus: "reject",
            acceptClassName: "p-button-info",
            accept: () => acceptSendEmail(usuario),
            reject,
          });

          toast.current.show({
            severity: "success",
            summary: "Successful",
            detail: response.data.success,
            life: 3000,
          });
        }
      } catch (error) {
        console.error("Error al actualizar la empresa:", error.message);
      }
    }
  };

  const editUsuario = async () => {
    setSubmitted(true);
    console.log("editUsuario", usuario);

    if (true === true) {
      try {
        if (usuario._id) {
          //editar usuario
          console.log("editar usuario", usuario);
          const response = await axios.put(
            "admin/users/update",
            JSON.stringify({ usuario }),
            {
              headers: { "Content-Type": "application/json" },
              withCredentials: true,
            }
          );
          console.log(response.data);
          GetUsuarios();
          toast.current.show({
            severity: "success",
            summary: "Successful",
            detail: response.data.success,
            life: 3000,
          });
        } else {
          //nuevo usuario
          const response = await axios.post(
            "admin/users/new",
            JSON.stringify({ usuario }),
            {
              headers: { "Content-Type": "application/json" },
              withCredentials: true,
            }
          );
          console.log(response.data);
          //setNewUsuarioDialog(false);
          //setUsuario(emptyUsuario);
          confirmDialog({
            message:
              "Desea enviar la informacion de acceso al usuario al correo " +
              usuario.email +
              " ?",
            header: "Envio de correo",
            icon: "pi pi-info-circle",
            defaultFocus: "reject",
            acceptClassName: "p-button-info",
            accept: () => acceptSendEmail(usuario),
            reject,
          });

          toast.current.show({
            severity: "success",
            summary: "Successful",
            detail: response.data.success,
            life: 3000,
          });
        }
      } catch (error) {
        console.error("Error al actualizar la empresa:", error.message);
      }
    }
  };

  const openEditUsuarioDialog = async (product) => {
    setUsuario({ ...product });
    setEditUsuarioDialog(true);
  };

  const sendUsuario = async (usuario) => {
    const response = await axios.post(
      "admin/users/send-credentials",
      JSON.stringify({ usuario }),
      {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      }
    );
    console.log(response.data);
  };
  const accept = async (user) => {
    const response = await axios.delete("admin/users/delete", {
      data: { id: user._id },
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });
    if (response.status === 200) {
      console.log("Usuario eliminado", response.data);
      toast.current.show({
        severity: "info",
        summary: "Eliminado",
        detail: "Usuario eliminado",
        life: 3000,
      });
      GetUsuarios();
    } else {
      toast.current.show({
        severity: "danger",
        summary: "Error",
        detail: "Ocurrio un error al eliminar el usuario",
        life: 3000,
      });
    }

    console.log(response.data);
  };
  const acceptSendEmail = async (usuario) => {
    // const response = await axios.delete("admin/users/delete", {
    //   data: { id: usuario._id },
    //   headers: { "Content-Type": "application/json" },
    //   withCredentials: true,
    // });
    const response = await axios.post(
      "admin/users/send-credentials",
      JSON.stringify({ usuario }),
      {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      }
    );
    if (response.status === 200) {
      console.log("Informacion enviada", response.data);
      toast.current.show({
        severity: "info",
        summary: "Enviado",
        detail: response.data.mensaje,
        life: 3000,
      });
      GetUsuarios();
    } else {
      toast.current.show({
        severity: "danger",
        summary: "Error",
        detail: "Ocurrio un error al eliminar el usuario",
        life: 3000,
      });
    }

    console.log(response.data);
  };

  const reject = () => {
    //toast.current.show({ severity: 'warn', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
  };
  const deleteUsuario = (user) => {
    console.log("deleteUsuario", user);
    confirmDialog({
      message:
        "Esta seguro que desea eliminar al usuario " + user.nombre + " ?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      defaultFocus: "reject",
      acceptClassName: "p-button-danger",
      accept: () => accept(user),
      reject,
    });
    // setUsuario({ ...user });
    // setEditEmpresaDialog(true);
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || "";
    let _product = { ...usuario };

    _product[`${name}`] = val;

    setUsuario(_product);
  };

  const leftToolbarTemplate = () => {
    return (
      <div className="flex flex-wrap gap-2">
        <Button
          label="Nuevo usuario"
          icon="pi pi-plus"
          severity="success"
          onClick={openNew}
        />
      </div>
    );
  };

  const rightToolbarTemplate = () => {
    return (
      <Button
        label="Export"
        icon="pi pi-upload"
        className="p-button-help"
        onClick={exportCSV}
      />
    );
  };

  const tableActionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          rounded
          outlined
          className="mr-2"
          onClick={() => openEditUsuarioDialog(rowData)}
        />
        <Button
          icon="pi pi-trash"
          rounded
          outlined
          severity="danger"
          className="mr-2 "
          onClick={() => deleteUsuario(rowData)}
        />
      </React.Fragment>
    );
  };

  const header = (
    <div className="flex flex-wrap gap-2 align-items-center justify-content-between">
      <h4 className="m-0"> </h4>
      <IconField iconPosition="left">
        <InputIcon className="pi pi-search" />
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Busqueda..."
        />
      </IconField>
    </div>
  );
  const newUserDialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        outlined
        onClick={hideDialog}
      />
      <Button label="Guardar" icon="pi pi-check" onClick={saveUsuario} />
    </React.Fragment>
  );

  const userEditDialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        outlined
        onClick={hideDialogEdit}
      />
      <Button label="Editar" icon="pi pi-check" onClick={editUsuario} />
    </React.Fragment>
  );

  const generatePassword = (length = 12) => {
    const charset =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+";
    let result = "";
    for (let i = 0; i < length; i++) {
      const index = Math.floor(Math.random() * charset.length);
      result += charset[index];
    }
    return result;
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUsuario((prev) => ({ ...prev, [name]: value }));
  };

  const handleGeneratePassword = () => {
    const newPassword = generatePassword(8);
    setUsuario((prev) => ({ ...prev, password: newPassword }));
  };
  const handleDireccionChange = (index, e) => {
    const { name, value } = e.target;
    const EmpresaNueva = [...usuario.Empresas];
    EmpresaNueva[index][name] = value;
    setUsuario((prev) => ({ ...prev, Empresas: EmpresaNueva }));
  };
  const eliminarDireccion = (index) => {
    console.log("eliminarDireccion", index);
    const nuevas = usuario.Empresas.filter((_, i) => i !== index);
    setUsuario((prev) => ({ ...prev, Empresas: nuevas }));
  };
  const agregarDireccion = () => {
    setUsuario((prev) => ({
      ...prev,
      Empresas: [
        ...prev.Empresas,
        {
          rfc: "",
          nombre: "",
          registrosPatronales: [{ registroPatronal: "", nombre: "" }],
        },
      ],
    }));
  };

  const handleReferenciaChange = (dirIndex, refIndex, e) => {
    const { name, value } = e.target;
    const nuevasEmpresas = [...usuario.Empresas];
    nuevasEmpresas[dirIndex].registrosPatronales[refIndex][name] = value;
    setUsuario((prev) => ({ ...prev, Empresas: nuevasEmpresas }));
  };

  const agregarReferencia = (dirIndex) => {
    const nuevasEmpresas = [...usuario.Empresas];
    nuevasEmpresas[dirIndex].registrosPatronales.push({
      registroPatronal: "",
      nombre: "",
    });
    setUsuario((prev) => ({ ...prev, Empresas: nuevasEmpresas }));
  };

  const eliminarReferencia = (dirIndex, refIndex) => {
    const nuevasEmpresas = [...usuario.Empresas];
    nuevasEmpresas[dirIndex].registrosPatronales.splice(refIndex, 1);
    setUsuario((prev) => ({ ...prev, Empresas: nuevasEmpresas }));
  };
  const [rolesSeleccionados, setRolesSeleccionados] = useState([]);
  const ROLES = {
    User: 2001,
    Editor: 1984,
    Admin: 5150,
  };
  const onRoleChange = (e, roleKey, roleValue) => {
    const newRoles = { ...usuario.roles };

    if (e.checked) {
      newRoles[roleKey] = roleValue;
    } else {
      delete newRoles[roleKey];
    }

    setUsuario({ ...usuario, roles: newRoles });
  };
  return (
    <div>
      {/* <FormularioUsuario /> */}
      <Toast ref={toast} />
      <ConfirmDialog />
      <div className="card">
        <Toolbar
          className="mb-4"
          left={leftToolbarTemplate}
          right={rightToolbarTemplate}
        ></Toolbar>

        <DataTable
          ref={dt}
          value={usuarios}
          selection={selectedEmpresas}
          onSelectionChange={(e) => setSelectedEmpresas(e.value)}
          dataKey="_id"
          paginator
          rows={10}
          rowsPerPageOptions={[5, 10, 25, 50]}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} products"
          globalFilter={globalFilter}
          header={header}
        >
          <Column selectionMode="multiple" exportable={false}></Column>
          <Column
            field="nombre"
            header="Nombre"
            sortable
            style={{ minWidth: "12rem" }}
          ></Column>
          <Column
            field="email"
            header="Email"
            sortable
            style={{ minWidth: "16rem" }}
          ></Column>
          <Column
            field="RFCS"
            header="RFCS"
            sortable
            style={{ minWidth: "10rem" }}
          ></Column>
          <Column
            body={tableActionBodyTemplate}
            exportable={false}
            style={{ minWidth: "12rem" }}
          ></Column>
        </DataTable>
      </div>

      <Dialog
        visible={newUsuarioDialog}
        style={{ width: "60vw" }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Nuevo usuario"
        modal
        className="p-fluid"
        footer={newUserDialogFooter}
        onHide={hideDialog}
      >
        <div className="grid gap-4">
          <div className="col-4">
            <label htmlFor="nombre" className="font-bold">
              Nombre
            </label>
            <InputText
              id="nombre"
              value={usuario.nombre}
              onChange={(e) => onInputChange(e, "nombre")}
              required
              autoFocus
              className={classNames({
                "p-invalid": submitted && !usuario.nombre,
              })}
            />
          </div>

          <div className="col-7">
            <label htmlFor="email" className="font-bold">
              Email
            </label>
            <InputText
              id="email"
              value={usuario.email}
              onChange={(e) => onInputChange(e, "email")}
              required
            />
          </div>

          <div className="col-4">
            <label htmlFor="password" className="font-bold">
              Password
            </label>
            <div className="flex align-items-center gap-2">
              <Password
                id="password"
                name="password"
                value={usuario.password}
                onChange={handleChange}
                toggleMask
                feedback={false}
                className="flex-1"
              />
              <Button
                icon="pi pi-refresh"
                type="button"
                onClick={handleGeneratePassword}
                tooltip="Generar contraseña"
              />
            </div>
          </div>
        </div>
        <div className="grid gap-4 mt-4">
          {usuario.Empresas.map((empresa, index) => (
            <div
              key={index}
              className="col-12 border-1 border-300 p-3 border-round"
            >
              <h5 className="m-0 mb-3">Empresa #{index + 1}</h5>

              <div className="grid gap-3">
                <div className="col-12 md:col-4">
                  <label className="block mb-1">RFC</label>
                  <InputText
                    name="rfc"
                    value={empresa.rfc}
                    onChange={(e) => handleDireccionChange(index, e)}
                  />
                </div>
                <div className="col-12 md:col-8">
                  <label className="block mb-1">Nombre</label>
                  <InputText
                    name="nombre"
                    value={empresa.nombre}
                    onChange={(e) => handleDireccionChange(index, e)}
                  />
                </div>
              </div>
              {empresa.registrosPatronales?.map((ref, refIndex) => (
                <div key={refIndex} className="grid gap-3 mt-2">
                  <div className="col-1 justify-content-center flex align-items-end">
                    <Button
                      type="button"
                      icon="pi pi-trash"
                      severity="danger"
                      label=""
                      onClick={() => eliminarReferencia(index, refIndex)}
                    />
                  </div>
                  <div className="col-3">
                    <label className="block mb-1">Registro patronal</label>
                    <InputText
                      name="registroPatronal"
                      value={ref.registroPatronal}
                      onChange={(e) =>
                        handleReferenciaChange(index, refIndex, e)
                      }
                    />
                  </div>

                  <div className="col-7">
                    <label className="block mb-1">Nombre(Alias)</label>
                    <InputText
                      name="nombre"
                      value={ref.nombre}
                      onChange={(e) =>
                        handleReferenciaChange(index, refIndex, e)
                      }
                    />
                  </div>
                </div>
              ))}
              <div className="mt-2 col-offset-9 col-3">
                <Button
                  type="button"
                  icon="pi pi-plus"
                  label="Registro patronal"
                  onClick={() => agregarReferencia(index)}
                  className="mb -3 col-12"
                />
              </div>
              <div className="m t-2 col-offset-9 col-3">
                <Button
                  type="button"
                  icon="pi pi-trash"
                  severity="danger"
                  label="Eliminar empresa"
                  className="m l-2 mb -3 col-12"
                  onClick={() => eliminarDireccion(index)}
                  disabled={usuario.Empresas.length === 1}
                />
              </div>
              <div></div>
            </div>
          ))}
          <div className="col-offset-4 col-4">
            <Button
              type="button"
              icon="pi pi-plus"
              label="Agregar empresa"
              onClick={agregarDireccion}
            />
          </div>
        </div>
      </Dialog>

      <Dialog
        visible={editUsuarioDialog}
        style={{ width: "32rem" }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Editar usuario"
        modal
        className="p-fluid"
        footer={userEditDialogFooter}
        onHide={hideDialogEdit}
      >
        <div className="field">
          <label htmlFor="nombre" className="font-bold">
            Nombre
          </label>
          <InputText id="nombre" value={usuario.nombre} autoFocus />
        </div>
        <div className="field">
          <label htmlFor="RFC" className="font-bold">
            Email
          </label>
          <InputText
            id="RFC"
            value={usuario.email}
            onChange={(e) => onInputChange(e, "email")}
            required
          />
        </div>
        <div className="field">
          <label htmlFor="password" className="font-bold">
            Password
          </label>
          {/* <Password
            id="password"
            name="password"
            value={usuario.password}
            onChange={handleChange}
            toggleMask
            feedback={false}
            className="flex-1"
          /> */}
          <Button
            icon="pi pi-refresh"
            label="Resetear contraseña"
            type="button"
            // onClick={handleGeneratePassword}
            tooltip="Generar contraseña"
          />
        </div>
        <div className="field">
          <label htmlFor="roles" className="font-bold">
            Roles
          </label>
          {/* <InputText id="roles" value={usuario.roles} autoFocus /> */}
          <div className="card flex justify-content-center">
            <div className="flex flex-wrap gap-3">
              {Object.entries(ROLES).map(([key, value]) => (
                <div key={value} className="flex align-items-center">
                  <Checkbox
                    inputId={`rol-${key}`}
                    name="rol"
                    value={value}
                    onChange={(e) => onRoleChange(e, key, value)}
                    //checked={rolesSeleccionados.includes(value)}
                    checked={usuario.roles.hasOwnProperty(key)}
                  />
                  <label htmlFor={`rol-${key}`} className="ml-2">
                    {key}
                  </label>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
}

const Users = () => {
  return (
    <>
      <h2>Gestión de Usuarios</h2>
      <TablaUsuarios />
    </>
  );
};
export default Users;
